export interface ISavedView {
  id?: string;
  description: string;
  reportConfiguration: string;
  title: string;
  reportId: string;
  entityId: number;
  previewEmbedId?: string;
  createdAt?: string;
}

export const createSavedView = (values: Partial<ISavedView> = {}): ISavedView => ({
  id: null,
  description: null,
  title: null,
  reportId: null,
  reportConfiguration: null,
  entityId: null,
  previewEmbedId: null,
  createdAt: null,
  ...values
});

export interface ISavedViewMetadata {
  id: string;
  createdBy: number;
  updatedBy: number;
  deletedAt: string;
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
  visibility: string;
}

export interface IReportAndSavedViewData {
  savedViewId: string;
  reportId: string;
  reportTitle: string;
  savedViewTitle: string;
}

export type ISavedViewPayload = ISavedView;
export type ISavedViewResponse = ISavedView & ISavedViewMetadata;
